import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom grupo-empresa"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-body pt-4"
  }, [_vm.carregando ? _c('div', {
    staticClass: "text-center py-10"
  }, [_c('span', {
    staticClass: "spinner spinner-primary"
  })]) : !_vm.grupo ? [_c('div', {
    staticClass: "alert alert-light-primary"
  }, [_vm._v(" Esta empresa ainda não pertence a um grupo empresarial. Ela será a matriz do novo grupo. ")]), _c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.criarGrupo.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome do grupo",
      "label-for": "nome-grupo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nome-grupo",
      "maxlength": "150",
      "placeholder": "Ex.: Grupo Empresarial",
      "required": ""
    },
    model: {
      value: _vm.novoGrupoNome,
      callback: function callback($$v) {
        _vm.novoGrupoNome = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "novoGrupoNome"
    }
  })], 1), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.salvando || !_vm.novoGrupoNome
    }
  }, [_vm.salvando ? _c('span', {
    staticClass: "spinner spinner-sm spinner-light mr-2"
  }) : _vm._e(), _vm._v(" Criar grupo empresarial ")])], 1)] : [_c('div', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between mb-6"
  }, [_c('div', [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s(_vm.grupo.nome))]), _c('span', {
    staticClass: "label label-inline",
    class: _vm.grupo.status === 'A' ? 'label-light-success' : 'label-light-danger'
  }, [_vm._v(" " + _vm._s(_vm.grupo.status === "A" ? "Ativo" : "Inativo") + " ")]), _c('span', {
    staticClass: "label label-inline label-light-primary ml-2"
  }, [_vm._v(" " + _vm._s(_vm.grupo.empresas_ativas || 0) + " de " + _vm._s(_vm.grupo.limite_empresas || 0) + " empresas ")])]), _vm.podeGerenciar ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm.grupo.status === 'A' ? _c('router-link', {
    staticClass: "btn btn-sm btn-light-warning mr-2",
    attrs: {
      "to": {
        name: 'grupoEmpresaPendencias'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle mr-1"
  }), _vm._v(" Central de pendências ")]) : _vm._e(), _vm.grupo.status === 'A' ? _c('router-link', {
    staticClass: "btn btn-sm btn-light-primary mr-2",
    attrs: {
      "to": {
        name: 'grupoEmpresaConsolidado'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-chart-bar mr-1"
  }), _vm._v(" Painel consolidado ")]) : _vm._e(), _c('router-link', {
    staticClass: "btn btn-sm btn-light-primary mr-2",
    attrs: {
      "to": {
        name: 'grupoEmpresaAuditoria'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-history mr-1"
  }), _vm._v(" Auditoria ")]), _c('button', {
    staticClass: "btn btn-sm",
    class: _vm.grupo.status === 'A' ? 'btn-light-danger' : 'btn-light-success',
    attrs: {
      "type": "button",
      "disabled": _vm.salvando
    },
    on: {
      "click": _vm.alternarStatusGrupo
    }
  }, [_vm._v(" " + _vm._s(_vm.grupo.status === "A" ? "Desativar grupo" : "Ativar grupo") + " ")])], 1) : _vm._e()]), !_vm.podeGerenciar ? _c('div', {
    staticClass: "alert alert-light-warning"
  }, [_vm._v(" A administração do grupo deve ser realizada acessando a empresa matriz. ")]) : _vm._e(), _c('section', {
    staticClass: "mb-10"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between mb-4"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Empresas do grupo")]), _vm.podeGerenciar && _vm.grupo.status === 'A' ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.salvando || _vm.cadastrandoFilial || _vm.limiteAtingido
    },
    on: {
      "click": _vm.abrirCadastroFilial
    }
  }, [_c('i', {
    staticClass: "fas fa-plus mr-1"
  }), _vm._v(" " + _vm._s(_vm.limiteAtingido ? "Limite atingido" : "Cadastrar nova filial") + " ")]) : _vm._e()]), _vm.limiteAtingido ? _c('div', {
    staticClass: "alert alert-light-warning py-2 px-3"
  }, [_vm._v(" O grupo atingiu o limite de empresas liberado no Multiempresa. ")]) : _vm._e(), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-vertical-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Empresa")]), _c('th', [_vm._v("Documento")]), _c('th', [_vm._v("Tipo")]), _vm.podeGerenciar ? _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ações")]) : _vm._e()])]), _c('tbody', _vm._l(_vm.grupo.membros, function (membro) {
    return _c('tr', {
      key: membro.id_grupo_empresa_membro
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.nomeEmpresa(membro.empresa)))])]), _c('td', [_vm._v(_vm._s(membro.empresa && membro.empresa.cnpj_cpf))]), _c('td', [_c('span', {
      staticClass: "label label-inline",
      class: membro.tipo === 'MATRIZ' ? 'label-light-primary' : 'label-light-info'
    }, [_vm._v(" " + _vm._s(membro.tipo === "MATRIZ" ? "Matriz" : "Filial") + " ")])]), _vm.podeGerenciar ? _c('td', {
      staticClass: "text-right"
    }, [membro.tipo !== 'MATRIZ' ? _c('button', {
      staticClass: "btn btn-sm btn-light-danger",
      attrs: {
        "type": "button",
        "disabled": _vm.salvando
      },
      on: {
        "click": function click($event) {
          return _vm.removerEmpresa(membro);
        }
      }
    }, [_vm._v(" Remover ")]) : _vm._e()]) : _vm._e()]);
  }), 0)])])]), _vm.podeGerenciar ? _c('section', {
    attrs: {
      "data-testid": "acessos-usuarios-matriz"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-4"
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Acesso dos usuários do grupo")]), _c('button', {
    staticClass: "btn btn-sm btn-light-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.carregandoUsuarios
    },
    on: {
      "click": _vm.carregarUsuarios
    }
  }, [_vm._v(" Atualizar ")])]), _vm.carregandoUsuarios ? _c('div', {
    staticClass: "text-center py-6"
  }, [_c('span', {
    staticClass: "spinner spinner-primary"
  })]) : !_vm.usuariosConfiguraveis.length ? _c('div', {
    staticClass: "alert alert-light-primary"
  }, [_vm._v(" Nenhum usuário ativo da matriz ou das filiais disponível para configurar o acesso. Cadastre o usuário em uma empresa do grupo e clique em Atualizar. ")]) : _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.usuariosConfiguraveis, function (usuario) {
    return _c('div', {
      key: usuario.id_emp_usuario,
      staticClass: "col-xl-6 mb-5"
    }, [_c('div', {
      staticClass: "border rounded p-5 h-100"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between mb-4"
    }, [_c('div', [_c('strong', {
      staticClass: "d-block"
    }, [_vm._v(_vm._s(usuario.nome))]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(usuario.email))]), _c('small', {
      staticClass: "text-muted d-block"
    }, [_vm._v(" Origem: " + _vm._s(usuario.empresa_origem) + " ")])]), usuario.admin ? _c('span', {
      staticClass: "label label-light-primary label-inline"
    }, [_vm._v(" Administrador ")]) : _vm._e()]), _c('b-form-group', {
      attrs: {
        "label": "Escopo de acesso"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.opcoesEscopo,
        "disabled": _vm.grupo.status !== 'A' || usuario.salvando
      },
      on: {
        "change": function change($event) {
          return _vm.normalizarEmpresasUsuario(usuario);
        }
      },
      model: {
        value: usuario.escopo_acesso,
        callback: function callback($$v) {
          _vm.$set(usuario, "escopo_acesso", $$v);
        },
        expression: "usuario.escopo_acesso"
      }
    })], 1), usuario.escopo_acesso === 'EMPRESAS_SELECIONADAS' ? _c('div', {
      staticClass: "mb-4"
    }, [_c('label', {
      staticClass: "font-weight-bold"
    }, [_vm._v("Empresas permitidas")]), _c('b-form-checkbox-group', {
      attrs: {
        "options": _vm.opcoesEmpresasGrupo(usuario),
        "stacked": "",
        "disabled": _vm.grupo.status !== 'A' || usuario.salvando
      },
      model: {
        value: usuario.empresas,
        callback: function callback($$v) {
          _vm.$set(usuario, "empresas", $$v);
        },
        expression: "usuario.empresas"
      }
    })], 1) : _vm._e(), _c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "type": "button",
        "disabled": !_vm.podeSalvarUsuario(usuario)
      },
      on: {
        "click": function click($event) {
          return _vm.salvarAcessoUsuario(usuario);
        }
      }
    }, [usuario.salvando ? _c('span', {
      staticClass: "spinner spinner-sm spinner-light mr-2"
    }) : _vm._e(), _vm._v(" Salvar acesso ")])], 1)]);
  }), 0)]) : _vm._e()]], 2), _c('b-modal', {
    attrs: {
      "id": "modal-cadastrar-filial",
      "title": "Cadastrar nova filial",
      "hide-footer": "",
      "centered": "",
      "size": "lg"
    },
    on: {
      "hidden": _vm.limparFormularioFilial
    }
  }, [_c('div', {
    staticClass: "alert alert-light-primary"
  }, [_vm._v(" A filial terá uma licença, configurações e dados próprios. Nada será copiado da matriz. ")]), _c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.cadastrarFilial.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-form-group', {
    staticClass: "col-md-7",
    attrs: {
      "label": "Razão social",
      "label-for": "filial-nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filial-nome",
      "maxlength": "70",
      "required": ""
    },
    model: {
      value: _vm.formFilial.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.formFilial, "nome", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formFilial.nome"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-5",
    attrs: {
      "label": "CPF/CNPJ",
      "label-for": "filial-documento"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['###.###.###-##', '##.###.###/####-##'],
      expression: "['###.###.###-##', '##.###.###/####-##']"
    }],
    attrs: {
      "id": "filial-documento",
      "inputmode": "numeric",
      "maxlength": "18",
      "required": ""
    },
    model: {
      value: _vm.formFilial.cnpj_cpf,
      callback: function callback($$v) {
        _vm.$set(_vm.formFilial, "cnpj_cpf", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formFilial.cnpj_cpf"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Nome fantasia",
      "label-for": "filial-fantasia"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filial-fantasia",
      "maxlength": "100"
    },
    model: {
      value: _vm.formFilial.nome_fantasia,
      callback: function callback($$v) {
        _vm.$set(_vm.formFilial, "nome_fantasia", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formFilial.nome_fantasia"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Responsável",
      "label-for": "filial-responsavel"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filial-responsavel",
      "maxlength": "100"
    },
    model: {
      value: _vm.formFilial.responsavel,
      callback: function callback($$v) {
        _vm.$set(_vm.formFilial, "responsavel", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formFilial.responsavel"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-7",
    attrs: {
      "label": "E-mail da filial",
      "label-for": "filial-email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filial-email",
      "type": "email",
      "maxlength": "100"
    },
    model: {
      value: _vm.formFilial.email,
      callback: function callback($$v) {
        _vm.$set(_vm.formFilial, "email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formFilial.email"
    }
  })], 1), _c('b-form-group', {
    staticClass: "col-md-5",
    attrs: {
      "label": "Telefone",
      "label-for": "filial-fone"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['(##) #### ####', '(##) # #### ####'],
      expression: "['(##) #### ####', '(##) # #### ####']"
    }],
    attrs: {
      "id": "filial-fone",
      "inputmode": "numeric",
      "maxlength": "16"
    },
    model: {
      value: _vm.formFilial.fone,
      callback: function callback($$v) {
        _vm.$set(_vm.formFilial, "fone", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formFilial.fone"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.cadastrandoFilial
    },
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-cadastrar-filial');
      }
    }
  }, [_vm._v(" Cancelar ")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.cadastrandoFilial || !_vm.formFilial.nome || !_vm.formFilial.cnpj_cpf
    }
  }, [_vm.cadastrandoFilial ? _c('span', {
    staticClass: "spinner spinner-sm spinner-light mr-2"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.cadastrandoFilial ? "Cadastrando..." : "Cadastrar filial") + " ")])])])], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 pt-6"
  }, [_c('div', {
    staticClass: "card-title w-100 justify-content-start text-left"
  }, [_c('div', [_c('h3', {
    staticClass: "card-label mb-1"
  }, [_vm._v("Multiempresas")]), _c('span', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(" Organize matriz, filiais e acessos dos usuários. ")])])])]);
}];
export { render, staticRenderFns };